// extracted by mini-css-extract-plugin
export default {"milestoneSeqWrap":"milestone-sequence_page_milestoneSeqWrap__vZrtM"};